import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=39b70a26&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=39b70a26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b70a26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b70a26')) {
      api.createRecord('39b70a26', component.options)
    } else {
      api.reload('39b70a26', component.options)
    }
    module.hot.accept("./user-profile.vue?vue&type=template&id=39b70a26&scoped=true", function () {
      api.rerender('39b70a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/account/views/user-profile.vue"
export default component.exports